"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var tryParseJson = exports.tryParseJson = function tryParseJson(json) {
	try {
		return JSON.parse(json);
	} catch (err) {
		console.error("Error parsing JSON", err);

		return null;
	}
};

var getLocalStorageItem = exports.getLocalStorageItem = function getLocalStorageItem(key) {
	return localStorage.getItem(key);
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/utils/LocalStorageHelper.js
// module id = 1990
// module chunks = 1